export default __webpack_public_path__ + "static/media/instagram-logo-negro.7791c364.svg";